<template>
  <!-- <van-grid :column-num="1">
    <van-grid-item>
      <van-image src="https://nong-dev-1301007541.file.myqcloud.com/uploads/img/2020/02/14/1-1581693714837392.png?sign=1584512759-1582444913-13133-d0a0e03fc497101419495870eec8927b" />
    </van-grid-item>
  </van-grid> -->
  <div class="category-container">
    <van-row>
      <van-col
        span="24"
        v-for="(category, index) in categories"
        :key="index"
        @click="onClick(category.id, $event)"
      >
        <Photo
          source="cdn"
          radius="5px"
          fit="contain"
          width="750rpx"
          height="397rpx"
          :img-id="category.banner"
        />
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import Photo from './photo.vue'
  import Vue from 'vue'
  import { Image } from 'vant'
  import { Col, Row } from 'vant'
  Vue.use(Image)
  Vue.use(Col).use(Row)
  // import { Grid, GridItem } from 'vant'
  // Vue.use(Grid).use(GridItem)
  export default {
    name: "CategoryList",
    components: {
      Photo,
    },
    props: {
      slug: String
    },
    watch: {
      'slug' (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.loadData()
        }
      }
    },
    data () {
      return {
        categories: []
      }
    },
    methods: {
      loadData () {
        let that = this
        let params = {
          slug: that.slug
        }
        that.$api.category.list(params).then(res => {
          window.console.log("获得栏目列表")
          window.console.log(res)
          that.categories = res.data.results
          that.$emit('categoriesCount', res.data.count)
        })
      },
      onClick (categoryId, event) {
        window.console.log(event)
        this.$router.replace({
          name: 'CategoryDetail',
          params: {
            categoryId: categoryId
          }
        })
      }
    },
    mounted () {
    }
  }
</script>

<style lang="css" scoped>
  .category-container {
    padding: 16px;
  }
</style>
